import React from "react";

export const MaterialIcon = props => {
	const { color, size, type, pointer, clickAction, id, className } = props;

	return (
		<i 
			onClick={clickAction}
			className={`material-icons -tv ${className || ""} ${size || "small"}${color ? ` -${color}` : ""}${pointer ? " -pointer" : ""}`}
			id={id}
		>
			{type}
		</i>
	);
};


// WEBPACK FOOTER //
// src/atoms/lib/MaterialIcon.js